import React, { Component } from 'react'
import styled from 'react-emotion'
import { Concept } from '../../application'
import { language } from '../../resources'

const Container = styled('div')`
  min-width: 320px;
  min-height: ${(props) => (props.minHeight ? props.minHeight : props.combi ? '150px' : '200px')};
  line-height: 0;
  background: url(${(props) => props.url});
  background-repeat: no-repeat;
  background-size: ${(props) => (props.loaded ? 'cover' : 'auto')};
  background-position: center;
  display: block;
  overflow: hidden;
  position: relative;
  height: ${(props) => (props.combi ? '100%' : 'unset')};

  @media (max-width: 992px) {
    width: ${(props) => (props.combi ? '50%' : '100%')};
    min-width: ${(props) => (props.combi ? 'unset' : '320px')};
    height: 400px;
  }

  @media (max-width: 767px) {
    min-height: 240px;
    max-height: 480px;
    height: unset;
  }
`

const ConceptWrapper = styled('div')`
  position: absolute;
  top: -1px;
  left: -1px;
  z-index: 3;
`

export default class ImageComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      src: props.preview || props.image,
    }
    this.downloadingImage = new Image()
  }

  componentDidMount() {
    const { image } = this.props
    if (image) {
      image.indexOf('w=') > 0 || image.indexOf('cdn/img/customer/') > 0 || language === 'uk' ? this.handleImage(image) : this.handleImage(`${image}${image.indexOf('?') > 0 ? '&' : '?'}w=1024`)
    }
  }

  componentDidUpdate(prevProps) {
    const { image } = this.props
    if (this.props.image !== prevProps.image) {
      this.downloadingImage.removeEventListener('load', this.setLoaded(''))
      image.indexOf('w=') > 0 || image.indexOf('cdn/img/customer/') > 0 || language === 'uk' ? this.handleImage(image) : this.handleImage(`${image}${image.indexOf('?') > 0 ? '&' : '?'}w=1024`)
    }
  }

  componentWillUnmount() {
    this.downloadingImage.removeEventListener('load', this.setLoaded(''))
  }

  setLoaded(src) {
    this.setState({ src, loaded: true })
  }

  handleImage(src) {
    this.downloadingImage.addEventListener('load', this.setLoaded(src))
    this.downloadingImage.src = src
  }

  render() {
    const { concept, name, oneOfCombi, image, productId } = this.props
    const { src, loaded } = this.state

    if (!image) return <Container url={src} title={name} />

    return (
      <Container url={src} loaded={loaded} title={name} combi={oneOfCombi} minHeight={this.props.minHeight}>
        {concept && (
          <ConceptWrapper>
            <Concept concept={concept} hotel={productId} />
          </ConceptWrapper>
        )}
      </Container>
    )
  }
}
